var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Link } from "core/components/Link";
import useClickOutside from "core/customHooks/useClickOutside";
import useScrollListener from "core/customHooks/useScrollListener";
import { colors, easing, fontWeight, mq, } from "core/styles/snippets";
import { content } from "core/utils";
import React, { useEffect, useRef, useState, } from "react";
import styled from "styled-components";
import { Container } from "./Container";
import { Details } from "./Details";
import { NavLink } from "./NavLink";
export var LoggedOutUserBadge = function (_a) {
    var className = _a.className, setHamburgerOpen = _a.setHamburgerOpen, hamburgerOpen = _a.hamburgerOpen;
    var _b = useState(false), showUserNav = _b[0], setShowUserNav = _b[1];
    var _c = useState(false), isFocused = _c[0], setIsFocused = _c[1];
    var handleOnFocus = function () {
        setIsFocused(true);
        setShowUserNav(true);
    };
    var handleBlur = function (e) {
        var _a;
        // Check if the new focused element is still within our component
        if (!((_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.relatedTarget))) {
            setShowUserNav(false);
        }
    };
    var scroll = useScrollListener();
    var detailsRef = useRef(null);
    var buttonRef = useRef(null);
    useClickOutside(detailsRef, function () {
        setShowUserNav(false);
    }, buttonRef);
    var menuLogics = function (showUserNav) {
        if (hamburgerOpen === true && showUserNav === false) {
            setHamburgerOpen(!hamburgerOpen);
            setShowUserNav(!showUserNav);
        }
        if (hamburgerOpen === false) {
            setShowUserNav(!showUserNav);
        }
    };
    useEffect(function () {
        if (hamburgerOpen === true && showUserNav === true) {
            setShowUserNav(false);
        }
    }, [hamburgerOpen]);
    useEffect(function () {
        if (scroll.y > 150 && scroll.y - scroll.lastY > 0) {
            setShowUserNav(false);
        }
    }, [scroll.y, scroll.lastY]);
    var currentOrigin = window.location.origin;
    var callbackUrl = "https://account.vtm.be/login?callback_url=".concat(currentOrigin, "/login-callback");
    function setCurrentUrlCookie() {
        document.cookie = "currentUrl=".concat((window.location.href), "; path=/; domain=vtm.be; secure; SameSite=Lax");
    }
    return (React.createElement(Container, { ref: buttonRef, className: className, tabIndex: 0, onFocus: handleOnFocus, onBlur: handleBlur, "data-component": "post-search-element" },
        React.createElement(StyledNavLink, { loggedIn: false, animation: true, label: content.userBadge.loggedOut.navItem.label, "data-gtm": content.userBadge.loggedOut.navItem.gtm, onClick: function () {
                menuLogics(showUserNav);
            }, opened: showUserNav }),
        React.createElement(Details, { ref: detailsRef, show: showUserNav },
            React.createElement(LoginLink
            // Login url here
            , { 
                // Login url here
                url: callbackUrl, "data-gtm": content.userBadge.loggedOut.callToAction.gtm, onClick: setCurrentUrlCookie }, content.userBadge.loggedOut.callToAction.label),
            React.createElement(RegisterLink, { url: callbackUrl, "data-gtm": content.userBadge.loggedOut.register.gtm, onClick: setCurrentUrlCookie }, content.userBadge.loggedOut.register.label))));
};
var StyledNavLink = styled(NavLink)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-right: 0;\n    line-height: 1;\n      color: ", ";\n\n    &:hover {\n        color: ", ";\n        text-decoration: underline;\n    }\n"], ["\n  padding-right: 0;\n    line-height: 1;\n      color: ", ";\n\n    &:hover {\n        color: ", ";\n        text-decoration: underline;\n    }\n"])), colors.link, colors.linkHover);
var LoginLink = styled(Link)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n  padding: 10px 3rem;\n  border: 0;\n  color: ", ";\n  cursor: pointer;\n  ", "\n  border-radius: 6.25rem;\n  background-color: ", ";\n  transition: all 0.25s ", ";\n\n  ", " {\n    &:hover {\n        background-color: ", "\n    }\n  }\n"], ["\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n  padding: 10px 3rem;\n  border: 0;\n  color: ", ";\n  cursor: pointer;\n  ", "\n  border-radius: 6.25rem;\n  background-color: ", ";\n  transition: all 0.25s ", ";\n\n  ", " {\n    &:hover {\n        background-color: ", "\n    }\n  }\n"])), colors.white, fontWeight.bold, colors.link, easing.expo.out, mq.hover("hover"), colors.linkHover);
var RegisterLink = styled(Link)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  cursor: pointer;\n  color: ", ";\n  text-decoration: none;\n  text-align: center;\n  display: block;\n  ", "\n  font-size: 1rem;\n  line-height: 1.1;\n\n  ", " {\n    &:hover {\n      text-decoration: underline;\n      color: ", ";\n    }\n  }\n"], ["\n  cursor: pointer;\n  color: ", ";\n  text-decoration: none;\n  text-align: center;\n  display: block;\n  ", "\n  font-size: 1rem;\n  line-height: 1.1;\n\n  ", " {\n    &:hover {\n      text-decoration: underline;\n      color: ", ";\n    }\n  }\n"])), colors.black, fontWeight.bold, mq.hover("hover"), colors.linkHover);
var templateObject_1, templateObject_2, templateObject_3;
